$(document).ready(
    function () {

        let sub_organizer_new_ajax_lock = false;

        $(document).on("submit", "#organizer_register_sub_organizer_form", function () {

            if ($(".alert").length) {
                $(".alert").remove();
            }

            if (!sub_organizer_new_ajax_lock) {

                sub_organizer_new_ajax_lock = true;

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer/new_sub_organizer",
                    data: {
                        serialized_post: $(this).serialize()
                    }
                })
                    .done(function (data) {

                        if (data.registerSubOrganizer !== undefined && data.registerSubOrganizer !== null) {
                            if (!$("#organizer_register_sub_organizer_form").hasClass('d-none')) {
                                $("#organizer_register_sub_organizer_form").addClass('d-none')
                            }
                            if ($("#organizer_register_success_message").hasClass('d-none')) {
                                $("#organizer_register_success_message").removeClass('d-none')
                            }
                        }

                    })
                    .fail(function (data) {

                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#div_organizer_register_button', data.responseJSON.error_message, 'danger', null, '#organizer_register_sub_organizer_form')
                        }

                        sub_organizer_new_ajax_lock = false;

                    })
                    .always(function () {
                        sub_organizer_new_ajax_lock = false;
                    });

            }

            return false;

        });

    }
)
;
